import { MediaPageState, mediaPageInitialState } from './State'

import {
  RESET,
  SET_FILE,
  SET_ERROR,
  SET_IS_UPLOADING,
  SET_IS_LOADING,
  SET_LINK_URL,
  SET_LINK_NAME,
  SET_IS_LINK_URL_VALID,
  SET_IS_SAVING_LINK,
  MediaPageAction
} from './Actions'

function mediaPageReducer(state: MediaPageState, action: MediaPageAction): MediaPageState {
  switch (action.type) {
    case SET_FILE:
      return {
        ...state,
        file: action.payload
      }
    case SET_ERROR:
      return {
        ...state,
        error: action.payload
      }
    case SET_IS_UPLOADING:
      return {
        ...state,
        isUploading: action.payload
      }
    case SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload
      }
    case SET_LINK_URL:
      return {
        ...state,
        linkUrl: action.payload
      }
    case SET_LINK_NAME:
      return {
        ...state,
        linkName: action.payload
      }
    case SET_IS_LINK_URL_VALID:
      return {
        ...state,
        isLinkUrlValid: action.payload
      }
    case SET_IS_SAVING_LINK:
      return {
        ...state,
        isSavingLink: action.payload
      }
    case RESET:
      return mediaPageInitialState
    default:
      return state
  }
}

export default mediaPageReducer
